import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { myBookingMenuPayloadParts } from '@app/my-booking/sub-components/menu-modal/menu-payload.state';
import { navigateToAnotherApp } from '@common/helpers';
import { FEATURE_TO_ROUTE_MAPPING } from '@common/helpers/constants/servicing.contant';
import { ReservationDetailPreviousPage } from '@common/interfaces';
import { MyBooking } from '@common/interfaces/mybooking/mybooking.interface';
import { MyBookingServiceService } from '@common/services/my-booking/my-booking-service/my-booking-service.service';
import { MyBookingStoreService } from '@common/services/my-booking/my-booking-store.service';
import { MyBookingService } from '@common/services/my-booking/my-booking.service';
import { ServicingCommonStoreService } from '@common/services/servicing-common-store/servicing-common-store.service';
import { SERVICING_ROUTES } from '@conf/routes.config';
import { environment } from '@env/environment';
import { CommonLibService } from '@lib/services/common-lib/common-lib.service';
import { ModalService } from '@lib/services/modal/modal.service';
import { map } from 'rxjs';

@Component({
  selector: 'asw-my-booking-sub-header',
  templateUrl: './my-booking-sub-header.component.html',
  styleUrls: ['./my-booking-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyBookingSubHeaderComponent {
  displayTitle$;
  isDisplay$;

  constructor(
    private _common: CommonLibService,
    private _modalService: ModalService,
    private router: Router,
    private _myBookingServiceService: MyBookingServiceService,
    private myBookingService: MyBookingService,
    private _myBookingStoreService: MyBookingStoreService,
    private readonly _servicingCommonStoreService: ServicingCommonStoreService
  ) {
    this.displayTitle$ = _myBookingStoreService.getMyBookingModel$().pipe(map(this.getDisplayTitle));
    this.isDisplay$ = _myBookingStoreService.getMyBookingModel$().pipe(map(this.getIsDisplay));
  }

  openMenuModal() {
    const part = myBookingMenuPayloadParts();
    this._modalService.showSubModal(part);
  }

  getIsDisplay(state: MyBooking) {
    // 1.「イベントID(1)」で設定したチェックインサービス申込=trueの場合、表示する。
    // 2.上記以外の場合、非表示とする。
    return state.checkInServiceApplication === true;
  }

  getDisplayTitle(state: MyBooking) {
    // 1.「イベントID(1)」で設定したチェックインサービス申込=trueの場合、サービスの表示である旨
    // 2.上記以外の場合、予約詳細である旨"
    return state.checkInServiceApplication === true ? 'label.serviceSelected' : 'label.reservationDetails';
  }

  /** (2) 戻るボタン押下処理 */
  onBack() {
    // 1.	予約詳細(サービス)(S01-P033)の[全サービスの編集情報破棄処理]を行う。
    this._myBookingServiceService.onHandleCommonNo3();

    // 2.	以下のパラメータのセッションストレージkey名として『servicingMybookingToCheckin』を保持する。
    const aswService = this._common.aswServiceStoreService.aswServiceData;
    sessionStorage.setItem(
      'servicingMybookingToCheckin',
      JSON.stringify({
        orderId: aswService.orderId,
        eTicketNumber: aswService.travelDocumentId,
        firstName: aswService.firstName,
        lastName: aswService.lastName,
        journeyID: this._myBookingStoreService.myBooking.journeyID,
        flightIds: this._myBookingStoreService.myBooking.flightIds,
        SITE_ID: 'RESERVATION',
      })
    );

    // 3. アプリケーションスコープstore.予約詳細遷移元画面区分を基に、直近の遷移元画面へ遷移する。
    const { functionId, pageId } = this._servicingCommonStoreService.servicingCommon
      ?.reservationDetailPreviousPage as ReservationDetailPreviousPage;
    const screenId = functionId + pageId;
    const params = {
      CONNECTION_KIND: 'ZZZ',
    };

    // サービシングの場合、サービシング共通storeからPNR情報取得API応答を削除する
    this._servicingCommonStoreService.updateServicingCommon({
      getOrder: {},
    });

    if (screenId === 'C01P050') {
      navigateToAnotherApp(environment.spa.app.cki, SERVICING_ROUTES.checkinReview, params);
    }
    if (screenId === 'C02P010') {
      navigateToAnotherApp(environment.spa.app.cki, SERVICING_ROUTES.checkinMybooking, params);
    }
  }

  /**
   * 遷移元画面が提携サイトかどうか
   * @returns 遷移元が提携サイトである場合はtrue
   */
  get backAllSite(): boolean {
    return this.myBookingService.getTransitionSourceFullFunctionPageId() === '-';
  }
}
